import { JSXElement, mergeProps } from 'solid-js';
import { getSlug } from '~/components/AppRouter/utils.ts';
import PortalContainer from '~/components/AppContainer/PortalContainer.tsx';
import WorkspaceContainer from '~/components/AppContainer/WorkspaceContainer.tsx';
import { ToastContextProvider } from '~/components/ui/Toast';
import { globalStore } from '~/stores';
import { AppContexts } from '~/utils/commonUtils.ts';
import HostedAuthContainer from '~/components/AppContainer/HostedAuthContainer.tsx';
import EnvAppPagesContainer from '~/components/AppContainer/EnvAppPagesContainer.tsx';

type AppContainerProps = {
  children: JSXElement;
};

export default function AppContainer(props: AppContainerProps): JSXElement {
  const merged = mergeProps({}, props);

  let Container = (props: { children: JSXElement }) => <>{props.children}</>;

  let pathName = window.location.pathname;

  if (pathName.startsWith(getSlug.customerPortalSSOBaseNamespace())) {
    Container = PortalContainer;
  } else if (pathName.startsWith(getSlug.workspaceBaseNamespace())) {
    Container = WorkspaceContainer;
  } else {
    switch (globalStore.appContext) {
      case AppContexts.CUSTOMER_PORTAL:
        Container = PortalContainer;
        break;
      case AppContexts.HOSTED_AUTH_PAGES:
        Container = HostedAuthContainer;
        break;
      case AppContexts.ENV_APP_PAGES:
        Container = EnvAppPagesContainer;
        break;
      case AppContexts.HANDLERS:
        // No separate container needed so far for the above routes
        break;
      case AppContexts.SCALEKIT_DASHBOARD:
      default:
        Container = WorkspaceContainer;
    }
  }

  return (
    <Container>
      <ToastContextProvider>{merged.children}</ToastContextProvider>
    </Container>
  );
}
